var _circle, _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMentorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 217,
    viewBox: "0 0 185 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "url(#paint0_linear_11_1154)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_1154",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 70,
    width: 103,
    height: 147
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5001,
    cy: 96.5663,
    rx: 27.5893,
    ry: 26.5663,
    fill: "#333333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5,
    cy: 172.723,
    rx: 51.5,
    ry: 44.2771,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_1154)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.0402,
    cy: 103.208,
    rx: 85.067,
    ry: 81.9127,
    fill: "#E9E4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 185H83.0017C83.3272 165.611 89.1373 148.143 89.1373 148.143H95.6057L95.6179 148.168C95.8608 148.94 102.679 166.008 103 185Z",
    fill: "#4763AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 131C83 131 87.7623 147.5 88.9776 147.855C90.1903 148.21 95.188 148.267 95.9012 147.855C96.6144 147.443 101.457 132.591 101.887 131C100.776 130.999 91.8881 136.143 91.8881 136.143L83 131Z",
    fill: "#32477A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_1154",
    x1: 93,
    y1: -40,
    x2: 92.5,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426985,
    stopColor: "#25374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768372,
    stopColor: "#547BAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorIcon);
export default __webpack_public_path__ + "static/media/Mentor Icon.edc8c608fe5471955870424119b16e24.svg";
export { ForwardRef as ReactComponent };